import { IsNotEmptyObject } from "../../../shared/utils/functions";
import { CompanyInsightApiEventData, MatchingTier } from "../models/company-insight.model";

export const TIERS = [1, 2, 3] as const;

export const SKILL_CHIPS = [
    88, 96, 72, 104, 80, 112,
    88, 76, 96, 88, 72, 104
] as const;

export const INITIAL_COUNT = 22;

export const BAR_COLOR_MAP = {
    bg: {
        blue: 'bg-[#E5F2FFED]',
        indigo: 'bg-[#E5F2FFED]',
        violet: 'bg-[#E5F2FFED]',
    },
    fill: {
        blue: 'bg-[#C0E0FF]',
        indigo: 'bg-[#C0E0FF]',
        violet: 'bg-[#C0E0FF]',
    },
    divider: {
        blue: 'bg-[#6FB6FB]',
        indigo: 'bg-[#6FB6FB]',
        violet: 'bg-[#6FB6FB]',
    },
    score: {
        blue: 'text-blue-600',
        indigo: 'text-indigo-600',
        violet: 'text-violet-600',
    },
} as const;

export interface TierLabels {
    viewedCandidates: string;
    shortlistedCandidates: string;
    invitedCandidates: string;
    viewed: string;
    shortlisted: string;
    invited: string;
    viewedDesc: string;
    shortlistedDesc: string;
    invitedDesc: string;
}

export const DEFAULT_TIER_LABELS: TierLabels = {
    viewedCandidates: 'Profile Viewed Candidates',
    shortlistedCandidates: 'Shortlisted Candidates',
    invitedCandidates: 'Invited Candidates',
    viewed: 'Profile Viewed',
    shortlisted: 'Shortlisted',
    invited: 'Invitation',
    viewedDesc: 'Score needed to get your',
    shortlistedDesc: 'Score needed to get',
    invitedDesc: 'Score needed to get your',
};

export function buildMatchingTiers(
    d: CompanyInsightApiEventData,
    labels: TierLabels,
): MatchingTier[] {
    return [
        {
            candidatesLabel: labels.viewedCandidates,   
            label: labels.viewed,                     
            description: labels.viewedDesc,   
            requiredScore: d.avgViewedScore,
            color: 'blue',
        },
        {
            candidatesLabel: labels.shortlistedCandidates, 
            label: labels.shortlisted,                     
            description: labels.shortlistedDesc,            
            requiredScore: d.avgShortlistScore,
            color: 'indigo',
        },
        {
            candidatesLabel: labels.invitedCandidates,  
            label: labels.invited,                      
            description: labels.invitedDesc,             
            requiredScore: d.avgInvitedScore,
            color: 'violet',
        },
    ];
}


export const GRID_CLASS_MAP: Record<number, string> = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-3',
};

export function formatLocation(location: string): string {
    if (location.trim().length === 0) return 'N/A';
    const parts = location.split(',').map(p => p.trim()).filter(p => p.length > 0);
    return parts.length > 2 ? 'Multiple Locations' : location;
}

export function hasCompanyInsightData(
    data: CompanyInsightApiEventData | null 
): boolean {
    if (!IsNotEmptyObject(data)) {
        return false;
    }
    return (data?.companyName === null || data?.companyName === undefined) ? false : !!data.companyName?.trim();
}

export type SharePlatform = 'facebook' | 'linkedin' | null;
export type BarColor = keyof typeof BAR_COLOR_MAP.bg;

 export const COMPANY_INSIGHT ="company-insight"